import React, { useState } from "react";
import { useSelector } from "react-redux";
import { CURRENCY } from "../../../contants";
import { RootUrl } from "../../../redux/types";
import price from "../../../helpers/calculatePrice";
import VariantSelectorModal from "../../../components/common/Modals/VariantSelectorModal";
import haptics from "../../../helpers/haptics";

const MobileItemsList = ({ items, onItemClick, activeOrder }) => {
  const [variantsItem, setVariantsItem] = useState(null);
  const { tables } = useSelector((state) => state.branch);
  const { activeOrders, activeOrder: activeOrderId } = useSelector((state) => state.order);
  const { isOnline, isAppOffline } = useSelector(
    (state) => state.networkStatus
  );
  const isElectron = window?.api?.isElectron;

  const active = activeOrders.find((order) => order.refId === activeOrderId);
  let tableType = tables.filter((table) => {
    return table?.tableNumber === active?.tableNumber;
  });

  if (active?.orderType === "Home Delivery") {
    tableType = [{ tableType: "Online" }];
  }

  const handleItemCardClick = (item) => {
    haptics.light();
    // Check if there's an active order/table selected
    if (!active) {
      alert("Please select a table or create an order first!");
      return;
    }

    if (item?.variants && item.variants.length > 0) {
      setVariantsItem(item);
    } else {
      onItemClick(item, false);
    }
  };

  const handleVariantClick = (variant, item) => {
    onItemClick(
      {
        ...item,
        ...variant,
        isVariant: true,
        variantId: variant?.id || variant?._id,
        itemName: `${item.itemName} ${variant.itemName}`,
      },
      true
    );
    setVariantsItem(null);
  };

  const makeToppingObject = (data) => {
    let toppings = {};
    data?.toppingField?.map(
      (extra) =>
        (toppings = {
          ...toppings,
          [extra?.toppingFieldName?.toLowerCase()]: data?.extras?.filter(
            (item) => item?.categories === extra?.toppingFieldName
          ),
        })
    );
    return toppings;
  };

  const getItemPrice = (item) => {
    return price(tableType[0]?.tableType, item) || item.itemPrice;
  };

  const getImageUrl = (item) => {
    if (!isOnline && !isAppOffline && isElectron) {
      return `file://C:/MealBill${item.itemImage}`;
    }
    return `${RootUrl}/${item?.itemImage}`;
  };

  if (!items || items.length === 0) {
    return (
      <div className="p-4">
        <div className="text-center py-5">
          <i className="mdi mdi-food-off mobile-no-items-icon"></i>
          <p className="text-muted mt-2">No items available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="px-3 all-items-list">
      <div className="row g-3">
        {items.map((item, index) => (
          <div key={index} className="col-6">
            <div
              className="card border-0 shadow-sm mobile-item-card cursor-pointer p-1 mb-2"
              onClick={() => handleItemCardClick(item)}
            >
              <div className="position-relative mobile-item-img-container">
                <img
                  src={getImageUrl(item)}
                  alt={item.itemName}
                  className="card-img-top w-100 h-100 mobile-item-img"
                  onError={(e) => {
                    e.target.src = "/images/placeholder-food.png";
                  }}
                />
                {item.rating && (
                  <div 
                    className="position-absolute top-0 end-0 m-2 bg-white rounded-pill px-2 py-1 d-flex align-items-center gap-1 mobile-item-rating"
                  >
                    <i className="mdi mdi-star text-warning"></i>
                    {item.rating}
                  </div>
                )}
              </div>
              <div className="card-body p-2">
                <h6 className="card-title text-dark fw-semibold text-truncate m-0">{item.itemName}</h6>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="fw-bold text-dark">{CURRENCY}{getItemPrice(item)}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {variantsItem && (
        <VariantSelectorModal
          open={Boolean(variantsItem)}
          onClose={() => setVariantsItem(null)}
          title={variantsItem?.itemName}
          extras={makeToppingObject(variantsItem)}
          categories={variantsItem?.toppingField}
          variants={variantsItem?.variants || []}
          onVariantClick={(variant) => handleVariantClick(variant, variantsItem)}
          tableType={tableType[0]?.tableType}
          onToppingSubmit={(data) => {
            // Handle topping submit if needed
            console.log("Toppings:", data);
          }}
        />
      )}
    </div>
  );
};

export default MobileItemsList;

